import 티아라_TRACKING_ID_조회 from './data/analysis/trackingId';
import getMyAccountInfoMock from '~/queries/servicePlatform/members/useMyAccountInfoQuery/mock';
import getServiceInfoMock from '~/queries/servicePlatform/members/useServiceInfoQuery/mock';
import getContentsBannerMock from '~/queries/useBannerQuery/mock';
import getContentsFooterMock from '~/queries/useFooterQuery/mock';

export function handlers() {
  return [
    getMyAccountInfoMock,
    getServiceInfoMock,
    getContentsBannerMock,
    getContentsFooterMock,
    티아라_TRACKING_ID_조회,
  ];
}
